import { $, T } from "../../common/drupal/drupal";

import Swiper, { Navigation, Pagination, Autoplay, Parallax } from "swiper";

/**
 * Class exemple de gestion du paragraph carousel testimonies
 */
class CarouselTestimoniesParagraph {

    /**
     * init
     */
    init() {
        const paragraphTestimoniesSwipers = [];
        Swiper.use([Navigation, Pagination, Autoplay, Parallax]);

        Array.from($('.ParagraphTestimoniesCarousel-carousel')).forEach((paragraph, i) => {
            let $numberOfSlides = $(paragraph).find('.swiper-slide').length;
            if ($numberOfSlides < 2) {
                $('.ParagraphTestimoniesCarousel-navigationBlock').hide();
            }
            if ($numberOfSlides > 1) {
                let paragraphImgs = $(paragraph).find('img');
                for (const paragraphImg of paragraphImgs) {
                    let articleImg = paragraphImg.closest('article');
                    articleImg.dataset.swiperParallax = '-150';
                    articleImg.dataset.swiperParallaxDuration = '650';
                }
                paragraphTestimoniesSwipers[i] = new Swiper(paragraph, {
                    spaceBetween: 20,
                    slidesPerView: 'auto',
                    autoHeight: true,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                    },
                    parallax: true,
                    // If we need pagination
                    pagination: {
                        el: $(paragraph).find('.ParagraphTestimoniesCarousel-pagination')[0],
                        type: 'fraction',
                    },

                    // Navigation arrows
                    navigation: {
                        nextEl: $(paragraph).find('.ParagraphTestimoniesCarousel-navigation-next')[0],
                        prevEl: $(paragraph).find('.ParagraphTestimoniesCarousel-navigation-prev')[0],
                    },
                });
            }
        })

    }

    /**
     * Attach.
     * @param context
     */
    attach(context) {
        if (T.contextIsRoot(context) && $('.ParagraphTestimoniesCarousel').length > 0) {
            this.init();
        }
    }
}

export let carouselTestimoniesParagraph = new CarouselTestimoniesParagraph();
